"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceColumn = exports.devicesColumn = void 0;
exports.devicesColumn = {
    type: 'devices',
};
exports.deviceColumn = {
    type: 'device',
};
//# sourceMappingURL=userapp.js.map